import { Symbol } from "@visactor/vrender-core";

export class PlayerIcon extends Symbol {
    constructor(params) {
        super(params);
    }
}
//# sourceMappingURL=icon.js.map
